/**
 * Subscription status utilities for extracting data from access token
 */ import { getAccessTokenPayload } from './jwt-utils';
/**
 * Mapping of access token offer keys to subscription status product keys
 */ const OFFER_MAPPING = {
    MATH_SUB: 'chegg_math',
    EB_SUB: 'chegg_writing_tool',
    BM_SUB: 'chegg_writing_tool',
    CM_SUB: 'chegg_writing_tool',
    CTFM_SUB: 'chegg_writing_tool',
    CTFM_LEGACY_SUB: 'chegg_writing_tool',
    EB_LEGACY_SUB: 'chegg_writing_tool',
    EB_SM_SUB: 'chegg_writing_tool',
    BM_LEGACY_SUB: 'chegg_writing_tool',
    CM_LEGACY_SUB: 'chegg_writing_tool',
    CS_SUB_6_MONTH: 'chegg_study',
    CS_SUB_12_MONTH: 'chegg_study',
    CS_SUB: 'chegg_study',
    CS_SUB_V2: 'chegg_study',
    CS_SUB_ONE_TIME: 'chegg_study',
    CS_SUB_ANNUAL: 'chegg_study',
    CS_MODERATOR: 'chegg_study',
    CS_SME: 'chegg_study',
    CS_1YR: 'chegg_study',
    LMS: 'chegg_study',
    CSP_SUB: 'chegg_study'
};
/**
 * Extract subscription status from access token
 * Returns subscription status for each product offering based on userTags.offers
 *
 * Returns:
 * - SubscriptionStatus object with "active"/"inactive" values when token is available
 * - null when access_token is not available
 */ export function getSubscriptionStatusFromToken() {
    try {
        const payload = getAccessTokenPayload();
        if (!payload?.userTags?.offers) {
            return null;
        }
        const offers = payload.userTags.offers;
        const result = {
            chegg_study: 'inactive',
            chegg_writing_tool: 'inactive',
            chegg_math: 'inactive'
        };
        if (offers.includes('CSP_SUB')) {
            return {
                chegg_study: 'active',
                chegg_writing_tool: 'active',
                chegg_math: 'active'
            };
        }
        // Check each product offering
        Object.entries(OFFER_MAPPING).forEach(([offerKey, productKey])=>{
            if (offers.includes(offerKey)) {
                result[productKey] = 'active';
            }
        // Note: we already set everything to 'inactive' by default, so no else needed
        });
        return result;
    } catch (error) {
        console.error('Error extracting subscription status from token:', error);
        return null;
    }
}
